import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AppComponent } from './app.component';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { EnvConfig, LanguageService } from '@doc/core';
import { environment } from '../environments/environment';
import { ApiInterceptorModule } from '@doc/api/interceptor'
import { PdfViewerModule } from 'ng2-pdf-viewer';
//import { AngularFileUploaderModule } from "angular-file-uploader";
import { NgxSpinnerModule } from "ngx-spinner";
import { ModalModule } from 'ngx-bootstrap/modal';
import { AuthGuard, PermissionGuard, PermissionService, SingleToastMessageService } from '@doc/api/server-bo';
import { ToastrModule } from 'ngx-toastr';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { GlobalToastComponent } from "../../../../libs/feature/document/src/lib/shared/global-toast/global-toast.component";
import { UploadIndicatorComponent } from "../../../../libs/feature/document/src/lib/upload-indicator/upload-indicator.component";
import { UploadMediaDialogComponent } from "../../../../libs/feature/document/src/lib/upload-media-dialog/upload-media-dialog.component";
import { GlobalErrorHandler } from './global-error-handler';

const msalConfig = {
  auth: {
    clientId: environment.azureAd?.clientId || '',
    authority: environment.azureAd?.authority || '',
    redirectUri: environment.azureAd?.redirectUri || '',
    navigateToLoginRequestUrl: false,
  }
};

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@doc/feature/auth').then(
      (module) => module.FeatureAuthModule
    ),
  },
  {
    path: 'shared-link/:token',
    loadComponent: () =>
    //  import('@doc/feature/document').then((m) => m.SharedLinkViewComponent),
      import('../../../../libs/feature/document/src/lib/shared/shared-link-view/shared-link-view.component').then((m) => m.SharedLinkViewComponent),
  },
  {
    path: 'main',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('@doc/feature/backoffice').then(
        (module) => module.FeatureBackofficeModule
      ),
  },
  {
    path: 'pshare',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('@doc/feature/backoffice').then(
        (module) => module.FeatureBackofficeModule
      ),
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  }];

const routeOptions: ExtraOptions = {
  // initialNavigation: 'enabled',
  onSameUrlNavigation: 'reload',
  scrollPositionRestoration: 'top',
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    ModalModule,
    HttpClientModule,
    ApiInterceptorModule,
    RouterModule.forRoot(routes, routeOptions),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
      },
    }),
    MsalModule.forRoot(new PublicClientApplication(msalConfig), {
      interactionType: InteractionType.Redirect,
      authRequest: { 
        scopes: environment.azureAd?.apiScopes || []
      },
    }, {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map([
        [environment.azureAd?.graphResource || '', environment.azureAd?.graphScopes || []],
        [environment.apiUrl, environment.azureAd?.apiScopes || []]
      ])
    }),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
      maxOpened: 1,
      timeOut: 5000,
      closeButton: false,
      progressBar: false,
      newestOnTop: true,
      tapToDismiss: true,
    }),
    GlobalToastComponent,
    UploadIndicatorComponent,
    UploadMediaDialogComponent
  ],
  providers: [
    LanguageService,
    SingleToastMessageService,
    PermissionService,
    PermissionGuard,
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: { prefix: '/assets/i18n/', suffix: '.json' },
    },
    { provide: EnvConfig, useValue: environment },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

